class AuthToken {
  static store(token) {
    window.localStorage.setItem("authToken", token);
  }

  static get() {
    return window.localStorage.getItem("authToken");
  }

  static purge() {
    window.localStorage.removeItem("authToken");
  }
}

const AuthTokenService = Object.freeze(AuthToken);
export default AuthTokenService;
